"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class WarningIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", style: this.props.style },
            React.createElement("path", { fill: fill, fillRule: "evenodd", d: "M13.756 3.219l8.63 15.823A2 2 0 0 1 20.632 22H3.369a2 2 0 0 1-1.756-2.958l8.63-15.823a2 2 0 0 1 3.513 0zM11 8v7h2V8h-2zm0 9v2h2v-2h-2z" })));
    }
}
exports.WarningIcon = WarningIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/warning.tsx
// module id = 641
// module chunks = 0 1 2